// extracted by mini-css-extract-plugin
export var flowchartContainer = "_v-0";